import { render, staticRenderFns } from "./KeyWordSettings.vue?vue&type=template&id=1db9b90f&scoped=true&"
import script from "./KeyWordSettings.vue?vue&type=script&lang=js&"
export * from "./KeyWordSettings.vue?vue&type=script&lang=js&"
import style0 from "./KeyWordSettings.vue?vue&type=style&index=0&id=1db9b90f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db9b90f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db9b90f')) {
      api.createRecord('1db9b90f', component.options)
    } else {
      api.reload('1db9b90f', component.options)
    }
    module.hot.accept("./KeyWordSettings.vue?vue&type=template&id=1db9b90f&scoped=true&", function () {
      api.rerender('1db9b90f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/KeyWordSettings.vue"
export default component.exports